export const MORE_ORGANIZER_EVENTS_CARD_WIDTH = 278;
export const MORE_ORGANIZER_EVENTS_CARD_IMAGE_HEIGHT = 158;
export const MORE_ORGANIZER_EVENTS_CAROUSEL_GAP = 16;
export const MORE_ORGANIZER_EVENTS_CAROUSEL_STEP =
  MORE_ORGANIZER_EVENTS_CARD_WIDTH + MORE_ORGANIZER_EVENTS_CAROUSEL_GAP;
